import { StackFrameMapper } from '../../../common/calls/mappers/StackFrameMapper';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportKey } from '../models/ReportKey';

export class ReportKeyMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();
  private readonly stackframeMapper = new StackFrameMapper();

  mapGQLModel(data: any, reportId: number): ReportKey {
    const firstCall = data.firstCallSite ? this.stackframeMapper.mapGQLModel(data.firstCallSite, 0) : null;
    const information = data.information?.length > 0 ? data.information : null;

    return new ReportKey(
      this.gqlIdEncoder.decode(data.id),
      reportId,
      data.shortDescription,
      data.locations.totalCount ?? 0,
      data.operationSummary ?? '',
      information,
      firstCall
    );
  }
}
